// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__e_dCm","title":"AfterBackImages_title__gXUM9","images":"AfterBackImages_images__2pfLC"};